import {Injectable} from '@angular/core';

import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpSentEvent,
} from '@angular/common/http';

import {EMPTY, Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<never>,
    next: HttpHandler,
  ): Observable<never> | Observable<HttpEvent<HttpSentEvent>> {
    if (request.url.indexOf(environment.host) === 0) {
      request = request.clone({
        withCredentials: true,
        // headers: csrftoken ? request.headers.set('X-CSRFToken', csrftoken) : request.headers
      });

      return next.handle(request).pipe(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        catchError((error: any) => {
          if (error.status === 401) {
            this.redirectToLogin();
            return EMPTY;
          }
          throw error;
        }),
      ) as Observable<never>;
    }

    return next.handle(request);
  }

  redirectToLogin(): void {
    window.location.href = environment.host + '?next=' + encodeURI(location.href);
  }
}
